import { alpha } from "@mui/system";

const useStyles = (theme) => ({
  paper: {
    display: "flex",
    height: "40px",
    padding: "0.5rem 0.75rem",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 2,
    borderRadius: 1,
    width: { xs: "100%", sm: "fit-content" },
    gap: 0.5,
    backgroundColor: theme.palette.background.paperLinkedMaps,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.background.paperSelectedMaps, 0.5),
    },
  },
  typography: {
    fontSize: "14px",
    fontWeight: "bold",
    height: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

export default useStyles;
